/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { Modal, Button, Carousel } from 'react-bootstrap'
import "../../css/SMPLButton.css"
import "../../css/Modal.css"
import AttireIcon from "../../icon/headshot-tips-attire.svg"
import AccessoriesIcon from "../../icon/headshot-tips-accessories.svg"
import { ReactComponent as LightIcon } from "../../icon/headshot-tips-light.svg"
import { ReactComponent as AngleIcon } from "../../icon/headshot-tips-angle.svg"
import { ReactComponent as FrameIcon } from "../../icon/headshot-tips-frame.svg"

import { ReactComponent as BackBracket } from "../../icon/back-bracket.svg"
import BobbingIcon from '../common/BobbingIcon'

interface HeadshotTipsModalProps {
  show: boolean
  onHide?: () => void
}

function HeadshotTipsModal({ show, onHide }: HeadshotTipsModalProps) {
  const [activeIndex, setActiveIndex] = useState<number>(0)

  const { t } = useTranslation()

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" id="headshotTips">
      <Modal.Body>
        <Carousel controls={false} onSelect={(eventKey: number, event: any) => setActiveIndex(eventKey)} activeIndex={activeIndex} interval={null}>
          <Carousel.Item>
            <BobbingIcon horizontalOffset="-73px" verticalOffset="-75px">
              <img src={AttireIcon} />
            </BobbingIcon>
            <h1>{t("headshotTips.appearance.title")}</h1>
            <p>
              <Trans i18nKey="headshotTips.appearance.text">
                <b></b>
              </Trans>
            </p>
          </Carousel.Item>
          <Carousel.Item>
            <BobbingIcon horizontalOffset="-73px" verticalOffset="-75px">
              <img src={AccessoriesIcon} />
            </BobbingIcon>
            <h1>{t("headshotTips.accessories.title")}</h1>
            <ul>
              <li>
                <Trans i18nKey="headshotTips.accessories.statements.line1">
                  <b></b>
                </Trans>
              </li>
              <li>
                <Trans i18nKey="headshotTips.accessories.statements.line2">
                  <b></b>
                </Trans>
              </li>
            </ul>
          </Carousel.Item>
          <Carousel.Item>
            <BobbingIcon horizontalOffset="-82px" verticalOffset="-90px">
              <LightIcon />
            </BobbingIcon>
            <h1>{t("headshotTips.light.title")}</h1>
            <p>{t("headshotTips.light.text")}</p>
          </Carousel.Item>
          <Carousel.Item>
            <BobbingIcon horizontalOffset="-87px" verticalOffset="-70px">
              <AngleIcon />
            </BobbingIcon>
            <h1>{t("headshotTips.angle.title")}</h1>
            <p>{t("headshotTips.angle.text")}</p>
          </Carousel.Item>
          <Carousel.Item>
            <BobbingIcon horizontalOffset="-83px" verticalOffset="-100px">
              <FrameIcon />
            </BobbingIcon>
            <h1>{t("headshotTips.frame.title")}</h1>
            <p>{t("headshotTips.frame.text")}</p>
          </Carousel.Item>
        </Carousel>

      </Modal.Body>
      <Modal.Footer>
        {activeIndex > 0 && <Button variant="link" id="headshotsBack" onClick={() => setActiveIndex(activeIndex - 1)}><BackBracket style={{ marginBottom: "3px" }} /> {t("headshotTips.back")}</Button>}

        {activeIndex < 4 ?
          <>
            <Button variant="smpl" className="float-right" onClick={() => setActiveIndex(activeIndex + 1)}>{t("headshotTips.next")}</Button>
          </>
          :
          <Button variant="smpl" onClick={onHide}>{t("headshotTips.close")}</Button>
        }
      </Modal.Footer>
    </Modal>
  )
}

export default HeadshotTipsModal
